import React from 'react'
import PropTypes from 'prop-types'
import ButtonCard from 'Components/ButtonCard'
import { useLocation, useParams } from 'react-router-dom'

const data = [
  { link: '/wholesale/product-list', title: 'B2B Master Product List' },
  { link: '/wholesale/product-list/active', title: 'B2B Active Product List' },
  { link: '/wholesale/product-list/pending', title: 'B2B Product Pending Approval' },
  { link: '/wholesale/product-list/inventory', title: 'B2B Inventory' },
]

function MenuButton(props) {
  const location = useLocation();
  return (
    <div style={{ display: 'flex' }} >
      {data.map(v => (<ButtonCard
        key={v.link}
        link={v.link}
        title={v.title}
        lightBlue
        selected={location.pathname === v.link}
      />))}
    </div>
  )
}

MenuButton.propTypes = {}

export default MenuButton
